import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { Link } from "react-router-dom";

import { updateSelectedItems } from '../../../redux/actions/products';
import { thresholdsByItem } from '../../../redux/actions/thresholds';

import LoadingSpinner from '../../partials/LoadingSpinner';

import UpdateThresholdModal from './UpdateThresholdModal';
import DeleteThresholdModal from './DeleteThresholdModal';

const ThresholdLine = ({ 
  payload,
  hasVariations,
  productId,
  itemId,
  smallThumbnailUrl,
  inventoryTracking,
  options,
  name,
  quantity,
  price,
  brand,
  selectedProductList,
  setSelectedProductList,
  products,
  type,
  rowId,
  targetInventory,
  setTargetInventory,
  lowInventory,
  setLowInventory,
  setCriticalInventory,
  criticalInventory,
  thresholds,
  itemThresholds,
  getThresholds,
  submitted,
  accountUnits,
  inStockFilter,
}) => {
  const [activeThreshold, setActiveThreshold] = useState(null);
  const [showUpdateThresholdModal, setShowUpdateThresholdModal] = useState(false);
  const [showDeleteThresholdModal, setShowDeleteThresholdModal] = useState(false);
  const [modalY, setModalY] = useState(0);

  const [lineThreshold, setLineThreshold] = useState(false);

  let section = !!options ? selectedProductList.variations : selectedProductList.products;
  let inList = Object.keys(section).indexOf(String(itemId)) > -1;

  useEffect(() => {
    if(type === 'variation') {
      getThresholds(payload, productId, itemId);
    } else {
      getThresholds(payload, productId, null);
    }
  }, []);

  useEffect(() => {
    setLineThreshold(false);

    if((type === 'variation') && itemThresholds[`${productId}/${itemId}`]) {
      setLineThreshold(itemThresholds[`${productId}/${itemId}`]);
    }

    if((type === 'product') && itemThresholds[`${productId}/null`]) {
      setLineThreshold(itemThresholds[`${productId}/null`]);
    }

  }, [thresholds]);

  const showEditModal = (event) => {
    let threshold = lineThreshold;
    threshold.product_id = productId;
    if(type === 'variation') { threshold.variation_id = itemId; }
    setActiveThreshold(threshold);
    setModalY(event.pageY);

    setShowUpdateThresholdModal(true);
  }

  const showDeleteModal = (event) => {
    let threshold = lineThreshold;
    threshold.product_id = productId;
    if(type === 'variation') { threshold.variation_id = itemId; }    
    setActiveThreshold(threshold);
    setModalY(event.pageY);

    setShowDeleteThresholdModal(true);
  }

  const switchSelection = () => {
    if (inList) {
      delete section[itemId];
    } else {
      section[itemId] = {
        productId: productId,
        smallThumbnailUrl: smallThumbnailUrl,
        options: options,
        name: name
      };
    }

    setSelectedProductList({ ...selectedProductList });
  };

  const setThresholdValue = (itemId, type, e, setter) => {
    section[itemId] = {
      productId: productId,
      smallThumbnailUrl: smallThumbnailUrl,
      options: options,
      name: name
    };

    setSelectedProductList({ ...selectedProductList });
    setter(itemId, type, e);

    if (e.target.value) {
      e.target.parentElement.classList.add("field--filled");
    } else {
      e.target.parentElement.classList.remove("field--filled");
    }
  }

  const format = (value) => {
    return (accountUnits.currencyPrefix + (parseFloat(value) || 0).toFixed(parseInt(accountUnits.currencyPrecision)) + accountUnits.currencySuffix).replace('.', accountUnits.currencyDecimalSeparator);
  }

  if(inStockFilter && !quantity) {
    return(
      <></>
    )
  }

  return(
    <>
      <div className="list-element list-element--normal list-element--has-hover">

        <div className="list-element__toggle">
          <input type="checkbox" value="on" checked={inList ? 'checked' : ''} id={itemId} tabindex="0" className="list-element__toggle-checkbox" onClick={() => switchSelection()}>
          </input>
          <label for={itemId} className="list-element__toggle-label">
          </label>
        </div>

        <div className="list-element__image">
          { smallThumbnailUrl && <img src={smallThumbnailUrl} /> }
          { !smallThumbnailUrl && <p>No image</p>}
        </div>

        <div className="list-element__content">
          <div className="list-element__info">
            <div className="list-element__header">
              <div className="list-element__main-info">
                <div className="list-element__title"><span>{name}</span></div>
              </div>
            </div>
            <div className="list-element__data-row">

            </div>
            <div className="list-element__data-row">
              <ul>
                { options && options.map(option =>
                    <li>
                      <strong>{ option.name }</strong>: <span className="inline-text-tag inline-text-tag--light-half">{ option.value }</span>
                    </li>
                  )
                }
                { quantity && 
                  <li>In Stock: <span className="inline-text-tag inline-text-tag--light-half">{ quantity }</span></li>
                }
                { brand &&
                  <li>Brand: <span className="inline-text-tag inline-text-tag--light-half">{ brand }</span></li>
                }
                { price &&
                  <li>Price: <span className="inline-text-tag inline-text-tag--light-half">{ format(price) }</span></li>
                }

                { !options &&
                  <p>
                    Base Product
                  </p>
                }
                { (inventoryTracking === 'none') &&
                  <p>Inventory not tracked</p>
                }
              </ul>
          </div>

        </div>
        <div className="list-element__actions">

          { !lineThreshold && !thresholds.itemSearchingThresholds.find(item => item === `${productId}/${itemId}`) &&
            <div className="fieldset">
              <div className="field field--medium">
                <label className="field__label">Target Inventory &nbsp;&nbsp;</label>
                <input
                  required
                  onChange={(e) => setThresholdValue(itemId, type, e, setTargetInventory)}
                  value={targetInventory}
                  type="number"
                  disabled={submitted}
                  className="field__input"
                />
                <div className="field__placeholder">Target Inventory</div>
              </div>

              <div className="field field--medium">
                <label className="field__label">Low Inventory &nbsp;&nbsp;</label>
                <input
                  required
                  onChange={(e) => setThresholdValue(itemId, type, e, setLowInventory)}
                  value={lowInventory}
                  type="number"
                  disabled={submitted}
                  className="field__input"
                />
                <div className="field__placeholder">Low Inventory</div>
              </div>

              <div className="field field--medium">
                <label className="field__label">Critical Inventory &nbsp;&nbsp;</label>
                <input
                  required
                  onChange={(e) => setThresholdValue(itemId, type, e, setCriticalInventory)}
                  value={criticalInventory}
                  type="number"
                  disabled={submitted}
                  className="field__input"
                />
                <div className="field__placeholder">Critical Inventory</div>
              </div>

            </div>
          }

          { thresholds.itemSearchingThresholds.find(item => item === `${productId}/${itemId}`) &&
            <LoadingSpinner
              size="xxSmall"
              statusText="Loading thresholds"
            />
          }

          { lineThreshold &&
            <>
              <div className="flex-1">
                <div className="left-15">
                  <h4>Threshold Details</h4>
                  <ul>
                    <li>Target Inventory: <span className="inline-text-tag">{lineThreshold.target_inventory || "Not set"}</span></li>
                    <li>Low Inventory: <span className="inline-text-tag">{lineThreshold.low_inventory || "Not set"}</span></li>
                    <li>Critical Inventory: <span className="inline-text-tag">{lineThreshold.critical_inventory || "Not set"}</span></li>
                  </ul>
                </div>
              </div>
              <div className="flex-1">
                <button
                  className={`btn btn-default ${thresholds.updatingThresholds.find(thresholdId => thresholdId === `${productId}/${itemId}`) ? 'btn-loading' : ''}`}
                  onClick={(event) => showEditModal(event)}
                  disabled={submitted || thresholds.updatingThresholds.find(thresholdId => thresholdId === `${productId}/${itemId}`)}
                  isLoading={thresholds.updatingThresholds.find(thresholdId => thresholdId === `${productId}/${itemId}`)}
                >
                  <span className="svg-icon">
                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18"><path d="M5.0355 15.7929 2.207 12.9645 1.5 16.5l3.5355-.7071z"/><path fill-rule="evenodd" clip-rule="evenodd" d="M12.8136.9437c.3906-.3905 1.0237-.3905 1.4143 0l2.8284 2.8284c.3905.3905.3905 1.0237 0 1.4142L5.5285 16.7141.2252 17.7748l1.0606-5.3033L12.8136.9437zm.7072 2.1213-9.8995 9.8995 1.4142 1.4142 9.8995-9.8995-1.4142-1.4142zM3.0071 15.1788l-.186-.186-.0464.2325.2324-.0465z"/></svg>
                  </span>
                  <span className="gwt-InlineLabel">Edit Thresholds</span>
                </button>
                <br/>
                <br/>
                <button
                  className={`btn btn-default btn--destructive ${thresholds.updatingThresholds.find(thresholdId => thresholdId === `${productId}/${itemId}`) ? 'btn-loading' : ''}`}
                  onClick={(event) => showDeleteModal(event)}
                  disabled={submitted || thresholds.updatingThresholds.find(thresholdId => thresholdId === `${productId}/${itemId}`)}
                  isLoading={thresholds.updatingThresholds.find(thresholdId => thresholdId === `${productId}/${itemId}`)}
                >
                  <span className="svg-icon">
                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18"><path d="M7 0h4l1 2H6l1-2z"/><path fill-rule="evenodd" clip-rule="evenodd" d="M2 3c-.5523 0-1 .4477-1 1s.4477 1 1 1v11c0 1.1046.8954 2 2 2h10c1.1046 0 2-.8954 2-2V5c.5523 0 1-.4477 1-1s-.4477-1-1-1H2zm12 13V5H4v11h10z"/><path d="M6 7.5c0-.5523.4477-1 1-1s1 .4477 1 1v6c0 .5523-.4477 1-1 1s-1-.4477-1-1v-6zM10 7.5c0-.5523.4477-1 1-1s1 .4477 1 1v6c0 .5523-.4477 1-1 1s-1-.4477-1-1v-6z"/></svg>
                  </span>
                  <span className="gwt-InlineLabel">Remove Thresholds</span>
                </button>
              </div>
            </>
          }
        </div>
      </div>
    </div>


      { showUpdateThresholdModal &&
        <UpdateThresholdModal
          payload={payload}
          showUpdateThresholdModal={showUpdateThresholdModal}
          setShowUpdateThresholdModal={setShowUpdateThresholdModal}
          threshold={activeThreshold}
          thresholdName={name}
          modalY={modalY}
        />
      }
      { showDeleteThresholdModal &&
        <DeleteThresholdModal
          payload={payload}
          showDeleteThresholdModal={showDeleteThresholdModal}
          setShowDeleteThresholdModal={setShowDeleteThresholdModal}
          threshold={activeThreshold}
          thresholdName={name}
          modalY={modalY}
        />
      }
    </>
  )
}

const mapStateToProps = state => ({
  accountUnits: state.accounts.account.store_details.formatsAndUnits,
  selectedProductList: state.products.selectedProductList,
  products: state.products,
  thresholds: state.thresholds,
  itemThresholds: state.thresholds.itemThresholds
});

const mapDispatchToProps = (dispatch) => ({
  setSelectedProductList: (items) => dispatch(updateSelectedItems(items)),
  getThresholds: (payload, productId, variationId) => dispatch(thresholdsByItem(payload, productId, variationId)),
});

export default connect(mapStateToProps, mapDispatchToProps)(ThresholdLine);
